module.exports = __webpack_public_path__ + "static/4-551894a23ad13234e1aae7da70def3b4.gif";